module.exports = __webpack_public_path__ + "open-iconic.527eff645d8ead16666a.otf";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/assets/open-iconic-master/font/fonts/open-iconic.otf
// module id = ../../../../../src/assets/open-iconic-master/font/fonts/open-iconic.otf
// module chunks = styles